import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import StorePage from "./pages/StorePage";
import ApplicationForm from "./pages/ApplicationForm";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<StorePage />} />
          <Route path="/apply" element={<ApplicationForm />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
